import { ShipType, shipTypes } from '../data/types/ship/ship-type';
import { IShip } from '../data/types/ship/ship';

export const getShipImage = (ship: IShip) => getShipTypeImage(ship.type);
export const getShipTypeImage = (shipType: ShipType) =>
  `/img/ships/ship${shipTypes.indexOf(shipType) - 1}.bmp`;
